"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessWorklease = exports.EvaluateWorklease = exports.StatusIterable = exports.RefreshSourceIterable = exports.DataConfig = void 0;
var DataConfig;
(function (DataConfig) {
    // *** SCHEMA ***
    DataConfig.SchemaItemTypeIterable = [
        'string',
        'number',
        'boolean',
    ];
    // *** DATA ACCESSOR ***
    DataConfig.AccessorTypeIterable = ['athena'];
})(DataConfig || (exports.DataConfig = DataConfig = {}));
exports.RefreshSourceIterable = ['glueCompletion', 'manual'];
exports.StatusIterable = [
    'initializedConfig', // Created config for materialized view
    'initializedTable', // Created MV table but haven't populated with data
    'refreshInProgress',
    'refreshComplete',
    'deleted',
    'errorCreateTable',
    'errorRefreshData',
    'errorDeleteTableAndConfig',
];
// ************************************************
//              EVALUATE WORKLEASE SETUP
// ************************************************
var EvaluateWorklease;
(function (EvaluateWorklease) {
    const WorkleaseTypeIterable = ['create', 'refresh', 'delete'];
})(EvaluateWorklease || (exports.EvaluateWorklease = EvaluateWorklease = {}));
// ************************************************
//               PROCESS WORKLEASE SETUP
// ************************************************
// NOTE: at the moment, this is the same set up as the "Evaluate" worklease
// above. Separated these two into their own in case they need to be different
// and some transformation process is done between them, as different lambdas
// process these workleases. If they continually stay the same and becomes onerous
// in managing two of the same instances, can consider consolidating them
var ProcessWorklease;
(function (ProcessWorklease) {
    const WorkleaseTypeIterable = ['create', 'refresh', 'delete'];
})(ProcessWorklease || (exports.ProcessWorklease = ProcessWorklease = {}));
//# sourceMappingURL=MaterializedView.js.map